"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIDescriptionList = _interopRequireDefault(require("UIComponents/list/UIDescriptionList"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _UITruncateString = _interopRequireDefault(require("UIComponents/text/UITruncateString"));

var _urls = require("../../../../utils/urls");

var I18N_PATH = 'appMarketplace.detail.overview.sidebar.privacy';

var Link = function Link(props) {
  return _react.default.createElement(_UILink.default, (0, _extends2.default)({}, props, {
    external: true,
    iconProps: {
      className: 'hidden'
    }
  }));
};

var PRIVACY_LINK = 'https://legal.hubspot.com/product-privacy-policy';
var TOS_LINK = 'https://legal.hubspot.com/terms-of-service';
var AUP_LINK = 'https://legal.hubspot.com/acceptable-use';

var Privacy = function Privacy(_ref) {
  var hubspotPolicy = _ref.hubspotPolicy,
      onTrackInteraction = _ref.onTrackInteraction,
      privacyUrl = _ref.privacyUrl,
      privacy2Url = _ref.privacy2Url,
      privacy3Url = _ref.privacy3Url,
      termsUrl = _ref.termsUrl;
  var trackInteraction = (0, _react.useCallback)(function (action) {
    return onTrackInteraction(action, 'data privacy');
  }, [onTrackInteraction]);
  var trackOtherPrivacyPolicyLinkClick = (0, _react.useCallback)(function () {
    return trackInteraction('click other privacy policy link');
  }, [trackInteraction]);
  return _react.default.createElement(_react.Fragment, null, _react.default.createElement("p", null, _react.default.createElement(_FormattedJSXMessage.default, {
    message: I18N_PATH + ".dataEnrichmentNotice_jsx",
    options: {
      aupLink: {
        href: AUP_LINK,
        onClick: function onClick() {
          trackInteraction('click acceptable use policy link');
        }
      },
      tosLink: {
        href: TOS_LINK,
        onClick: function onClick() {
          trackInteraction('click customer terms of service link');
        }
      }
    },
    elements: {
      Link: Link
    }
  })), _react.default.createElement(_UIDescriptionList.default, null, _react.default.createElement("dt", null, _react.default.createElement(_FormattedMessage.default, {
    message: I18N_PATH + ".privacyPolicyLabel"
  })), hubspotPolicy ? _react.default.createElement("dd", null, _react.default.createElement(_FormattedJSXMessage.default, {
    message: I18N_PATH + ".privacyPolicyHS_jsx",
    options: {
      productPrivacyLink: {
        href: (0, _urls.getFormattedUrl)(PRIVACY_LINK),
        onClick: function onClick() {
          trackInteraction('click product privacy policy link');
        }
      },
      privacyLinkProps: {
        href: (0, _urls.getFormattedUrl)(privacyUrl),
        onClick: function onClick() {
          trackInteraction('click privacy policy link');
        }
      },
      tosLinkProps: {
        href: (0, _urls.getFormattedUrl)(termsUrl),
        onClick: function onClick() {
          trackInteraction('click terms link');
        }
      }
    },
    elements: {
      Link: Link
    }
  })) : _react.default.createElement("dd", null, _react.default.createElement(_FormattedJSXMessage.default, {
    message: I18N_PATH + ".privacyPolicy_jsx",
    options: {
      privacyLinkProps: {
        href: (0, _urls.getFormattedUrl)(privacyUrl),
        onClick: function onClick() {
          return trackInteraction('click privacy policy link');
        }
      },
      tosLinkProps: {
        href: (0, _urls.getFormattedUrl)(termsUrl),
        onClick: function onClick() {
          return trackInteraction('click terms link');
        }
      }
    },
    elements: {
      Link: Link
    }
  })), (privacy2Url || privacy3Url) && _react.default.createElement(_react.Fragment, null, _react.default.createElement("dt", null, _react.default.createElement(_FormattedMessage.default, {
    message: I18N_PATH + ".additionalPrivacyInformationLabel"
  })), _react.default.createElement("dd", null, _react.default.createElement(_UIList.default, null, privacy2Url && _react.default.createElement(Link, {
    href: (0, _urls.getFormattedUrl)(privacy2Url),
    onClick: trackOtherPrivacyPolicyLinkClick
  }, _react.default.createElement(_UITruncateString.default, null, privacy2Url)), privacy3Url && _react.default.createElement(Link, {
    href: (0, _urls.getFormattedUrl)(privacy3Url),
    onClick: trackOtherPrivacyPolicyLinkClick
  }, _react.default.createElement(_UITruncateString.default, null, privacy3Url)))))));
};

Privacy.propTypes = {
  hubspotPolicy: _propTypes.default.bool.isRequired,
  onTrackInteraction: _propTypes.default.func.isRequired,
  privacyUrl: _propTypes.default.string.isRequired,
  privacy2Url: _propTypes.default.string,
  privacy3Url: _propTypes.default.string,
  termsUrl: _propTypes.default.string.isRequired
};
var _default = Privacy;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/detail/overview/sidebar/Privacy.js
// module id = 833
// module chunks = 209 210 211 212